import { render, staticRenderFns } from "./menuRegistration.vue?vue&type=template&id=6a28513c&scoped=true"
import script from "./menuRegistration.vue?vue&type=script&lang=js"
export * from "./menuRegistration.vue?vue&type=script&lang=js"
import style0 from "./menuRegistration.vue?vue&type=style&index=0&id=6a28513c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a28513c",
  null
  
)

export default component.exports